(function(){
    'use strict';
    
    angular
        .module('completeAir')
        .controller('offersCtrl', offersCtrl)
        .controller('deleteOfferCtrl', deleteOfferCtrl)
        .controller('newOfferCtrl', newOfferCtrl)
        .controller('editOfferCtrl', editOfferCtrl);

    offersCtrl.$inject = ['linkService', 'offers', '$stateParams'];
    deleteOfferCtrl.$inject = ['linkService', '$uibModalInstance', 'offer', 'offerService'];
    newOfferCtrl.$inject = ['cities', '$stateParams', 'offerService'];
    editOfferCtrl.$inject = ['linkService', 'offer', 'cities', '$stateParams', 'offerService'];

    function offersCtrl(linkService, offers, $stateParams){
        var vm = this;
        vm.linkService = linkService;
        vm.offers = (offers.data._embedded) ? offers.data._embedded.offers : [];
        vm.pages = offers.data.page;
        vm.disalbeNewOfferButton = false;
        vm.isAllView = $stateParams.originId == 0;
        vm.selectedOrigin = null;

        vm.handleOriginSelected = function(id, option) {
            vm.selectedOrigin = {
                id: id,
                option: option
            };

            if (id === 0) {
                vm.disalbeNewOfferButton = true;
            }
            else {
                vm.disalbeNewOfferButton = false;
            } 
        };
    }

    function deleteOfferCtrl(linkService, $uibModalInstance, offer, offerService){
        var vm = this;
        vm.origin = offer.data._embedded.airports[0]._embedded.region.name;
        vm.destination = offer.data._embedded.airports[1]._embedded.region.name;
        vm.linkService = linkService;

        vm.deleteOffer = function(){
            offerService.deleteOffer(linkService.getLinkId(offer.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function newOfferCtrl(cities, $stateParams, offerService) {
        var vm = this;
        var originId = $stateParams.originId;
        vm.isEditSection = false;
        vm.origins = cities;
        vm.destinations = angular.copy(cities).filter(function(o) {
                return o.id != originId;
            }) || null;

        var selectedOrigin = vm.origins.filter(function(o) {
            return o.id == originId;
        })[0] || null;

        vm.offer = {
            origin: selectedOrigin,
            destination: null,
            price: null,
            currencyBOB: true,
            imageUrl: null
        };

        vm.saveOffer = function(isValid, offer) {
            if (isValid) {
                var newOffer = {
                    originAirportId: offer.origin.id,
                    destinyAirportId: offer.destination.id,
                    currency: (offer.currencyBOB) ? 'BOB' : 'USD',
                    price: parseInt(offer.price),
                    imageUrl: offer.imageUrl
                }

                offerService.saveOffer(newOffer, { originId: originId });
            }
        }
    }

    function editOfferCtrl(linkService, offer, cities, $stateParams, offerService){
        var vm = this;
        vm.linkService = linkService;
        vm.origins = vm.destinations = cities;
        vm.isEditSection = true;
        var originId = parseInt(linkService.getLinkId(offer.data._embedded.airports[0]._links.self.href));
        var destionationId = parseInt(linkService.getLinkId(offer.data._embedded.airports[1]._links.self.href));

        var origin = vm.origins.filter(function(c) {
            return c.id == originId;
        })[0] || null;

        var destination = vm.destinations.filter(function(c) {
            return c.id == destionationId;
        })[0] || null;

        vm.offer = {
            origin: origin,
            destination: destination,
            price: offer.data.price,
            currencyBOB: (offer.data.currency == 'BOB') ? true : false,
            imageUrl: offer.data.imageUrl
        };

        vm.saveOffer = function(isValid, offer) {
            if (isValid) {
                var updatedOffer = {
                    originAirportId: offer.origin.id,
                    destinyAirportId: offer.destination.id,
                    currency: (offer.currencyBOB) ? 'BOB' : 'USD',
                    price: parseInt(offer.price),
                    imageUrl: offer.imageUrl
                }

                offerService.updateOffer(updatedOffer, $stateParams.id, { originId: originId });
            }
        }
    }
})();